module.exports = __webpack_public_path__ + "static/media/welcome.d77ead38.svg";